import { Component, Input } from '@angular/core';
import { LsnErrorStateMatcher } from '../error-state-matcher';

@Component({
    selector: 'app-errors',
    styleUrls: ['./errors.component.scss'],
    templateUrl: './errors.component.html',
})
export class ErrorsComponent {
    @Input() errorStateMatcher: LsnErrorStateMatcher;
    @Input() bigger: boolean = false;

    value = null;
}
